import { Box, BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { MOBILE_TABS } from "./nav-items";
import { TopAppBar } from "./TopAppBar";

export function MobileShell({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTabValue =
    MOBILE_TABS.find((t) =>
      t.path === "/accounts"
        ? location.pathname === "/accounts"
        : location.pathname.startsWith(t.path)
    )?.path ?? false;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <TopAppBar />
      <Box
        component="main"
        sx={{
          flex: 1,
          px: 2,
          pb: "calc(72px + env(safe-area-inset-bottom))",
          pt: 2
        }}
      >
        {children}
      </Box>
      <Paper
        elevation={0}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: (theme) => theme.zIndex.appBar
        }}
      >
        <BottomNavigation
          value={currentTabValue}
          onChange={(_, v) => v && navigate(v)}
          showLabels
        >
          {MOBILE_TABS.map(({ label, path, icon: Icon }) => (
            <BottomNavigationAction
              key={path}
              value={path}
              label={label}
              icon={<Icon />}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
